import styled from '@emotion/styled';

export const PopupContent = styled.div`
  padding: 32px 24px;
  background: var(--colorWhite);
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  width: calc(100% - 64px);
  max-width: 400px;
  max-height: calc(100% - 128px);
  overflow-y: auto;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  h2 {
    margin: 0;
  }
`;

export const LargePopupContent = styled(PopupContent)`
  max-width: 600px;
  max-height: 80%;
  overflow-y: auto;
  padding: 40px 32px;

  h2 {
    font-size: 40px;
  }

  p {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media screen and (max-width: 600px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;
